module.exports = __webpack_public_path__ + "img/small-5.b09a7234.webp";